import { ThumbnailType } from "../models/map/thumbnailtypes";

export const URL_CDN = 'https://static.spqr.app';
export const URL_CDN_PUBLIC = `${URL_CDN}/public`;

export enum SpqrUrls {
    EditProfile = '/user/editprofile',
    Game = '/game',
    Login = '/user/login',
    Map = '/map',
    Stats = '/stats',
    LogClientEvent = '/api/logclientevent',
    VerifyEmail = '/user/verifyemail'
}

export const URL_LOGIN = '/user/login';

export const ALLOWED_LOGIN_CALLBACK_URL_PAGE_RES = [
    /^\/$/,
    /^\/game$/,
    /^\/game\/play\?id=\d+$/,
    /^\/stats$/,
    /^\/map$/,
    /^\/map\/edit/,
    /^\/api\//,
];

export const isValidLoginCallbackUrl = (callbackUrl: string): boolean =>
    ALLOWED_LOGIN_CALLBACK_URL_PAGE_RES.some(url_re => callbackUrl.match(url_re));

export const urlLoginWithCallback = (callbackUrl: string): string => {
    if (!isValidLoginCallbackUrl(callbackUrl)) {
        callbackUrl = '/';
    }
    return SpqrUrls.Login + '?callbackUrl=' + encodeURIComponent(callbackUrl);
}

export function urlVerifyEmailWithCallback(callbackUrl: string): string {
    if (!isValidLoginCallbackUrl(callbackUrl)) {
        callbackUrl = '/';
    }

    return process.env.NEXTAUTH_URL
        + SpqrUrls.VerifyEmail
        + '?callbackUrl='
        + encodeURIComponent(callbackUrl);
}

export const urlEditMap = (mapId: number) => `/map/edit/${mapId}`;

export const urlImageCard = (cardPrefix: string, cardId: number) => `https://static.spqr.app/public${cardPrefix}/${cardId}.jpg`

export const DEFAULT_URL_CARD_PREFIX = '/cards';

export const urlMapAsset = (asset: string) => `${URL_CDN_PUBLIC}${asset}`;
export const urlAvatar = (avatar: string) => `${URL_CDN}/avatars/${avatar}`;

export const urlMapThumbnail = (
    mapId: number,
    thumbnailType: ThumbnailType = ThumbnailType.Icon,
) => `${process.env.NEXTAUTH_URL}/api/map/getthumbnail?mapId=${mapId}&type=${thumbnailType}`;
